(function () {
    'use strict';

    angular
        .module('app')
        .factory('contactService', contactService);

    contactService.$inject = ['$http'];

    function contactService($http) {
        var service = {
            send: send
        };

        return service;

        function send(model, success, error) {
            return $http.post('/api/contactrequest/v2/send', JSON.stringify(model), { cache: false })
                .then(function(result) {
                    success(result.data);
                }, function(err) {
                    error(err);
                });
        }
    }
})();